module.exports = __webpack_public_path__ + "img/finans.4cdb1a9c.jpg";